import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";

const HealthCare = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Health Care</h6>
          <hr />
          <h1 className="banner-title">
            Revolutionize healthcare with <br /> advanced analytics and
            solutions
          </h1>

          <p>
            Leverage cutting-edge software and analytics to improve patient
            outcomes and operational efficiency in healthcare.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/medium-shot-doctor-checking-blood-pressure-female-patient_1098-19334.jpg"
          alt="Healthcare Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Health Care</h6>
              <h2 className="text-center">
                Committed to Delivering Quality Care
              </h2>
              <p className="text-center">
                We enable healthcare providers to offer outstanding care,
                anytime and anywhere, while ensuring cost efficiency. Through
                innovative, patient-focused solutions, we help transform
                healthcare operations and foster cross-industry collaboration.
                Our smart, personalized, and data-driven strategies prioritize
                what matters most in healthcare—delivering value to patients.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center"> Our Solutions for Healthcare</h2>
              <p className="text-center mb-0">
                Harness innovative software and data analytics to revolutionize
                healthcare management and patient outcomes.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                <a href="#">Patient Data Analytics</a>
              </h4>
              <p className="mb-4">
                Leverage patient data to improve treatment plans, predict
                outcomes, and provide personalized care.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                <a href="#">Hospital Management</a>
              </h4>
              <p className="mb-4">
                Optimize hospital operations, manage patient records, and
                improve care with our software solutions.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                <a href="#">Telemedicine Solutions</a>
              </h4>
              <p className="mb-4">
                Facilitate virtual consultations and remote monitoring for
                seamless patient care.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">
                <a href="#">Patient Engagement Tools</a>
              </h4>
              <p className="mb-4">
                Boost patient engagement with mobile apps and personalized
                communication.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      {/* <section id="about_pg" className="p_3 bg-light">
        <div className="container-xl">
          <h2 className="text-center mt-3">Our Clients</h2>

          <div className="row">
            <div className="col-md-4 text-center mt-4">
              <img style={{ maxWidth: "40%", height: "40%" }} src="./assets/img/logo.png" alt="" />
            </div>

             <div className="col-md-4 text-center mt-4">
              <img style={{ maxWidth: "40%", height: "40%" }} src="https://www.nextgenmyhealth.com/assets/Website-Logo-3848179b.png" alt="" />
            </div>
          </div>
        </div>
      </section> */}

      <section id="serv_h" className="p_3 mt-5">
        <div className="container" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4 text-center">
            <div className="col-md-12">
              <div className="serv_h1l">
                <h3>Our Clients</h3>
                {/* <p className="mb-0">Trusted by leading innovators worldwide.</p> */}
              </div>
            </div>
          </div>

          <div className="my-swiper-container">
            <Swiper
              modules={[]}
              spaceBetween={30} // Adjust space between slides
              slidesPerView={3} // Show exactly 3 slides
              loop={true} // Enable infinite looping
              centeredSlides={false} // No centering needed if all 3 are visible
              style={{
                width: "100%", // Make the Swiper full-width
              }}
            >
              {/* Slide 1 */}
              <SwiperSlide>
                <img
                  src="./assets/img/logo.png"
                  alt="React.js"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Slide 2 */}
              <SwiperSlide>
                <img
                  src="https://www.hospinetics.com/static/img/logo.svg"
                  alt="upay"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>

              {/* Slide 3 */}
              <SwiperSlide>
                <img
                  src="https://www.nextgenmyhealth.com/assets/Website-Logo-3848179b.png"
                  alt="Client Logo 4"
                  style={{
                    width: "120px",
                    height: "80px",
                    objectFit: "contain",
                    margin: "auto",
                  }}
                />
              </SwiperSlide>
            </Swiper>

            <div className="my-swiper-button-prev"></div>
            <div className="my-swiper-button-next"></div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">Ready to Transform Healthcare?</h2>
                <p className="mt-3">
                  Let’s explore how our software and analytics solutions can
                  revolutionize healthcare operations, improve patient outcomes,
                  and drive efficiency.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HealthCare;
